import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d4bb6c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "frisbuy-mobile-video-speed-menu",
  role: "menu",
  "aria-label": "Playback speed"
}
const _hoisted_2 = ["aria-checked", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "frisbuy-mobile-video-speed-menu__check",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M2.5 7.2L5.3 10L11.5 3.8",
  stroke: "#FFFFFF",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupReviewMobileVideoSpeedMenu',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const speedOptions = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

function select(value: number) {
  emit("update:modelValue", value);
  emit("close");
}

function formatSpeed(value: number) {
  if (value === 1) return "Normal";
  return `${value}x`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(speedOptions, (option) => {
      return _createElementVNode("button", {
        key: option,
        type: "button",
        class: _normalizeClass(["frisbuy-mobile-video-speed-menu__item", { 'frisbuy-mobile-video-speed-menu__item--active': option === _ctx.modelValue }]),
        role: "menuitemradio",
        "aria-checked": option === _ctx.modelValue,
        onClick: ($event: any) => (select(option))
      }, [
        _createElementVNode("span", null, _toDisplayString(formatSpeed(option)), 1),
        (option === _ctx.modelValue)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2)
    }), 64))
  ]))
}
}

})